export const planningConstants = {
    GET_PLANNINGS: "GET_PLANNINGS",
    GET_PLANNING: "GET_PLANNING",
  };